"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Detail = void 0;
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const styled_components_1 = __importDefault(require("styled-components"));
const apiService_1 = __importDefault(require("../../../common/services/apiService"));
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const ConventionDetail_1 = __importDefault(require("../Detail/ConventionDetail"));
const CheckinErrorWrapper = styled_components_1.default.div `
  text-align: center;
  padding: 20px;
`;
const Detail = (props) => {
    const [checkinError, setCheckinError] = (0, react_1.useState)("");
    const [activeConvention, setActiveConvention] = (0, react_1.useState)({});
    const { code } = props.match.params;
    const checkinConvention = () => {
        if (!code) {
            return;
        }
        apiService_1.default
            .checkInConvention(props.currentLocale, props.userData.token, code)
            .then((data) => {
            if (data.status === "error") {
                setCheckinError(data.message);
            }
            else {
                // eslint-disable-next-line no-use-before-define
                fetchUserConventions();
            }
        });
    };
    const fetchUserConventions = () => {
        apiService_1.default
            .getUserConventions(props.currentLocale, props.userData.token)
            .then((data) => {
            const conventionContent = data.find((convention) => convention.code === code);
            if (conventionContent) {
                setActiveConvention(conventionContent);
            }
            else {
                checkinConvention();
            }
        });
    };
    (0, react_1.useEffect)(() => {
        if (code) {
            fetchUserConventions();
        }
        else {
            setCheckinError("Invalid code.");
        }
    }, []);
    if (checkinError) {
        return react_1.default.createElement(CheckinErrorWrapper, null, checkinError);
    }
    if (Object.keys(activeConvention).length > 0) {
        return react_1.default.createElement(ConventionDetail_1.default, { conventionData: activeConvention });
    }
    return react_1.default.createElement(react_1.default.Fragment, null);
};
exports.Detail = Detail;
const mapStoreToProps = (store) => ({
    currentLocale: store.getValue("currentLocale"),
    baseUrl: store.getValue("baseUrl"),
    userData: store.getValue("userData"),
});
exports.default = (0, react_router_dom_1.withRouter)((0, withStore_1.default)(mapStoreToProps)(exports.Detail));
